@custom-media --mobile (max-width: 768px);

.boxContainer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & > article {
    flex-basis: 48%;
    margin-bottom: 2rem;

    @media (--mobile) {
      flex-basis: 100%;
    }
  }
}
